export default __webpack_public_path__ + "static/sportsjaw-77751140083d461351107cb24b54c309.svg";